import React from 'react';
import LegalPage from '../../components/LegalPage';

export default function PriceDisclaimer() {
  return (
    <LegalPage eyebrow="Legal" title="Price & Availability Disclaimer" updated="July 2025">
      <h2>Demonstration data (current phase)</h2>
      <p>During this partner-integration phase, the Website may display demonstration search results including sample airlines, hotels, car-rental vehicles, prices and availability. These are for illustration only and must not be relied on as bookable inventory.</p>
      <h2>Live pricing (future)</h2>
      <p>Once live partner integrations are activated:</p>
      <ul>
        <li>Prices, taxes, fees, inclusions and availability are supplied by third-party providers.</li>
        <li>They may change at any time, including between search and booking.</li>
        <li>The final price and inclusions are confirmed by the relevant provider at the point of booking.</li>
        <li>You may be redirected to a third-party provider to complete a booking, quotation or purchase.</li>
        <li>Currency conversions, where displayed, are indicative only.</li>
      </ul>
      <h2>Verification</h2>
      <p>Please verify all pricing, availability and inclusions with the relevant provider before completing a booking.</p>
      <h2>Contact</h2>
      <p><a href="mailto:admin@waantravel.com">admin@waantravel.com</a></p>
    </LegalPage>
  );
}
